import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { RouterModule }   from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { CWSMSAPIService } from './cwsmsapi.service';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { SendsmsComponent } from './sendsms/sendsms.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  MatSidenavModule,
  MatTabsModule,
  MatSelectModule,
  MatDialogModule,
  MatIconModule
} from '@angular/material';
import { ApiComponent } from './api/api.component';
import { FileImportComponent } from './file-import/file-import.component';
import { CountrySelectorComponent } from './country-selector/country-selector.component';
import { BuyCreditsComponent } from './buy-credits/buy-credits.component';
import { RecipientListsComponent } from './recipient-lists/recipient-lists.component';
import { MessageLogComponent } from './message-log/message-log.component';
import { BillingInfoComponent } from './billing-info/billing-info.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { httpFactory } from '@angular/http/src/http_module';
import { HttpClientModule, HttpClient } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  exports: [
    MatSidenavModule,
    MatTabsModule,
    MatSelectModule,
    MatDialogModule,
    MatIconModule
  ]
})
export class MaterialModule {}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    SidemenuComponent,
    SendsmsComponent,
    ApiComponent,
    FileImportComponent,
    CountrySelectorComponent,
    BuyCreditsComponent,
    RecipientListsComponent,
    MessageLogComponent,
    BillingInfoComponent,
    AdminDashboardComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    HttpModule,
    MaterialModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    RouterModule.forRoot([
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'send',
        component: SendsmsComponent
      },
      {
        path: 'api',
        component: ApiComponent
      },
      {
        path: 'log',
        component: MessageLogComponent
      },
      {
        path: 'billing',
        component: BillingInfoComponent
      },
      {
        path: 'admin',
        component: AdminDashboardComponent
      },
      {
        path: 'buy',
        component: BuyCreditsComponent
      }
    ])
  ],
  providers: [
    CWSMSAPIService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    FileImportComponent,
    BuyCreditsComponent,
    RecipientListsComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts